/* eslint-disable no-redeclare */
import React from 'react'
import _ from 'common-tools/LodashHelper'
import { ah, sh, ReduxWrapper, compose } from 'common-data/datahelpers'

export const FindFirstRoute = (NavLinks, SessionUser, SessionAccount) => {
  const navs = _.map(NavLinks, (navLink) => {
    let hasUserAccess = true
    let hasAccountAccess = true
    if (SessionUser) {
      hasUserAccess = SessionUser.HasPermissions(navLink.permissions)
    }
    if (SessionAccount) {
      hasAccountAccess = SessionAccount.HasPermissions(navLink.permissions)
    }
    return {
      link: navLink.link,
      hasAccess: hasAccountAccess || hasUserAccess
    }
  })

  const firstNav = _.find(navs, { hasAccess: true })

  if (!firstNav) {
    return null
  } else {
    return firstNav.link
  }
}

class IndexRoutePlain extends React.Component {
  constructor (props) {
    super(props)
    const { routeAddIndexRoute, uri } = this.props
    if (uri) {
      routeAddIndexRoute(`${uri}`)
    }
  }

  render () {
    const { SessionAccount, SessionUser, NavLinks, uri, navigate, to } = this.props

    if (!to) {
      var firstNavlink = FindFirstRoute(NavLinks, SessionUser, SessionAccount)
    } else {
      var firstNavlink = to
    }

    if (!firstNavlink) {
      return <p>Looks like you do not have access to any of these menus!</p>
    } else {
      navigate(`${uri || ''}${_.startsWith(firstNavlink, '/') ? '' : '/'}${firstNavlink}`)
      return null
    }
  }
}

export const IndexRoute = compose(
  ReduxWrapper([
    sh.SessionAccount,
    sh.SessionUser
  ], [
    ah.routeAddIndexRoute,
    ah.sendToURL
  ])
)(IndexRoutePlain)
